import { useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { PlayIcon } from '@app-velocity/icons';

import {
  useScenarioDetailsContext,
  useUserSimulationControl,
} from '@app-velocity/modules/scenarios';

import { ActionButton } from '../ActionButton';

export const ActionStart = () => {
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { t } = useI18n();
  const { scenario } = useScenarioDetailsContext();
  const { start } = useUserSimulationControl();

  const handleStart = () => {
    if (!scenario || !workspaceId || !teamId) return;
    start(teamId, workspaceId, scenario.id!);
  };

  return (
    <ActionButton onClick={handleStart}>
      {t('prototypes:start_simulation')} <PlayIcon />
    </ActionButton>
  );
};
